import $ from 'jquery';
import 'whatwg-fetch';
import './lib/owl-carousel/owl.carousel.min';
import { windowOnLoad } from './common';
import './slide-footer';

/* eslint-disable */
const req = require.context('../css/career', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

(() => {
	let activeFlag = 1;
	let introduceData;
	let blogData;
	const carouselControl = document.querySelector('.carousel-container > .carousel-control');
	const sliderSection = document.querySelector('.content-section.-slider');
	const profileContent = document.querySelector('.scroll-block');
	const profileMobileArray = document.querySelectorAll('.member.profile-card');
	const profileDesktopArray = document.querySelectorAll('.profile-member > .profile-card');
	const blogLinkGroup = document.querySelector('.blog-wrapper > .blogbody > .type');
	const blogImageGroup = document.querySelectorAll('.image-wrapper > .blogimage');
	const memberIntroContainer = document.querySelector('.detail');
	const typeButton = document.querySelectorAll('.blog-wrapper > .blognavi > .navi-wrapper > .type');
	const naviWrapper = document.querySelector('.blog-wrapper > .blognavi > .navi-wrapper');
	const slide = $('.carousel-container > .owl-carousel');
	const member = $('.member.owl-carousel');

	// 點擊員工照片，切換對應自我介紹
	const showMemberContent = () => {
		/* make introduce content scroll to top after switch member circle image. */
		memberIntroContainer.scrollTop = 0;
		profileContent.innerHTML = introduceData[activeFlag - 1];
	};

	// 初始化 Blog List (預設是 type 1) & 當點擊 type button 切換對應Blog List
	const setUpBlogList = (dataType) => {
		if (blogLinkGroup.hasChildNodes()) {
			blogLinkGroup.innerHTML = '';
		}
		blogImageGroup.forEach((imgWrapper) => {
			imgWrapper.childNodes.forEach((child) => {
				child.style.opacity = '0';
				if (child.dataset.image === `${dataType}-1` || child.dataset.image === `${dataType}-2`) {
					child.style.opacity = '1';
				}
			});
		});

		blogData[dataType - 1].forEach((blog, index) => {
			const anchor = document.createElement("a");
			anchor.href = blog.link;
			anchor.textContent = blog.text;
			anchor.target = '_blank';
			anchor.setAttribute("class", "bloglink");
			anchor.setAttribute('data-text', `Story_0${index + 1}`);

			// blogImageGroup.appendChild(anchor);
			blogLinkGroup.appendChild(anchor);
		});
	};

	// 當 網頁往下 scroll 時，滑到banner時才開始執行自動輪播
	const autoplayStart = () => {
		if (window.scrollY >= sliderSection.offsetTop) {
			slide.trigger('play.owl.autoplay', [5000]);
		}
	};

	// 點擊 member 照片 顯示對應自我介紹
	const showProfileContent = (e) => {
		profileMobileArray.forEach((profile) => {
			profile.classList.remove('active');
		});

		profileDesktopArray.forEach((profile) => {
			profile.classList.remove('active');
		});

		activeFlag = e.currentTarget.dataset.id;
		e.currentTarget.classList.add('active');
		showMemberContent();
		member.trigger('to.owl.carousel', activeFlag - 1);
	};

	// 製作 resize 時 輪播按鈕定位
	const resizeCarouselControl = () => {
		const activedCarousel = document.querySelector('.owl-item.active.center');
		carouselControl.style.top = `${activedCarousel.getBoundingClientRect().height / 2}px`;
		carouselControl.style.transform = 'translate(-50%, -50%)';
	};

	/**
	 * Q0. 初始化內容
	 */
	fetch('static/json/career.json')
		.then((response) => response.json())
		.then((json) => {
			// fetch json data to show interview section content
			introduceData = json.introduce;
			blogData = json.blog;
			showMemberContent();
			setUpBlogList(1);
		});

	/**
	 * Q2. There is a slider of banner (為什麼要加入新芽)
	 */
	window.addEventListener('scroll', autoplayStart);
	window.addEventListener('resize', resizeCarouselControl);

	slide.owlCarousel({
		loop: true,
		center: true,
		nav: false,
		margin: 20,
		items: 2,
		autoplay: true,
		autoplaySpeed: 2000,
		dotsSpeed: 2000,
		autoplayTimeout: 4000,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1,
				margin: 0,
			},
			720: {
				items: 1.35,
			},
			1280: {
				items: 1.5,
			},
		},
	});

	// 製作輪播遮罩
	document.querySelector('.owl-item.active.center').style.opacity = '1';
	if (document.body.clientWidth > 720) {
		// translate、translated、changed
		slide.on('translated.owl.carousel', () => {
			const bannerElmCollect = document.querySelectorAll('.carousel-container .owl-item');
			for (const bannerImg of bannerElmCollect) {
				bannerImg.style.opacity = '0.5';

				if (bannerImg.classList.contains('center')) {
					bannerImg.style.opacity = '1';
				}
			}
		});
	}

	// 製作輪播手機touch事件左右移動
	slide[0].childNodes[0].addEventListener('click', (e) => {
		if (document.body.clientWidth / 2 > e.x) {
			slide.trigger('prev.owl.carousel');
		} else {
			slide.trigger('next.owl.carousel');
		}
	});

	// 製作輪播按鈕事件
	$(".carousel-container > .carousel-control > .prev-btn").click(() => {
		slide.trigger('stop.owl.autoplay');
		slide.trigger('prev.owl.carousel', [2000]);
		slide.trigger('play.owl.autoplay', [4000]);
	});

	$(".carousel-container > .carousel-control > .next-btn").click(() => {
		slide.trigger('stop.owl.autoplay');
		slide.trigger('next.owl.carousel', [2000]);
		slide.trigger('play.owl.autoplay', [4000]);
	});

	// 這行要放在初始化輪播之後才行
	resizeCarouselControl();
	/**
	 * Q4. This is methods for interview section. (新芽人的生活)
	 */

	// 初始 member 輪播
	member.owlCarousel({
		loop: true,
		items: 1,
	});

	// 點擊向左按鈕(member))
	$(".prev-btn").click(() => {
		if (activeFlag <= 1) {
			activeFlag = 4;
			// 配合member個數
		} else {
			activeFlag -= 1;
		}
		member.trigger('prev.owl.carousel');
		profileDesktopArray.forEach((profile) => {
			profile.classList.remove('active');
		});

		profileDesktopArray[activeFlag - 1].classList.add('active');
		showMemberContent();
	});

	// 點擊向右按鈕(member))
	$(".next-btn").click(() => {
		if (activeFlag >= 4) {
			activeFlag = 1;
			// 配合member個數
		} else {
			activeFlag += 1;
		}
		member.trigger('next.owl.carousel');

		profileDesktopArray.forEach((profile) => {
			profile.classList.remove('active');
		});

		profileDesktopArray[activeFlag - 1].classList.add('active');
		showMemberContent();
	});

	profileDesktopArray.forEach((profile) => {
		profile.addEventListener('click', showProfileContent);
	});

	/**
	 * Q5. Our Story 新芽足跡 - 切換 blog type 按鈕
	 */
	const switchActive = (target) => {
		typeButton.forEach((button) => {
			button.classList.remove('active');
		});
		target.classList.add('active');
		setUpBlogList(target.dataset.type);
	};

	typeButton.forEach((button) => {
		button.addEventListener('click', (e) => {
			switchActive(e.currentTarget);
		});
	});

	/**
	 * Q5. Our Story 新芽足跡 - 手機版拖拉效果
	 */
	let startX = 0;
	let startScroll = 0;
	let startTime = 0;
	let moved = false;

	const startDrag = (e) => {
		naviWrapper.classList.add('active');
		startX = e.pageX;
		startScroll = naviWrapper.scrollLeft;
		startTime = new Date().getTime();
		moved = false;
	};

	const dragHandler = (e) => {
		e.preventDefault();
		if (naviWrapper.classList.contains('active')) {
			const move = e.pageX - startX;
			naviWrapper.scrollLeft = startScroll - (move * 3);
			moved = true;
		}
	};

	const stopDrag = (e) => {
		naviWrapper.classList.remove('active');
		if (new Date().getTime() - startTime <= 250) {
			if (e.pageX > startX) {
				console.log("swipe right");
			} else if (e.pageX < startX) {
				console.log("swipe left");
			}
		}
	};
	// for desktop
	naviWrapper.addEventListener('mousedown', startDrag);
	naviWrapper.addEventListener('mouseup', stopDrag);
	naviWrapper.addEventListener('mousemove', dragHandler);
	naviWrapper.addEventListener('mouseleave', stopDrag);
	// for mobile
	naviWrapper.addEventListener('touchstart', startDrag);
	naviWrapper.addEventListener('touchend', stopDrag);
	naviWrapper.addEventListener('touchmove', dragHandler);

	document.querySelectorAll(".navi-wrapper a").forEach((dom) => {
		dom.addEventListener("click", (e) => {
			if (moved) {
				e.preventDefault();
			}
		});
	});
})();

window.onload = () => {
	windowOnLoad();
};



// WEBPACK FOOTER //
// ./src/js/career.js